import React from 'react';
import { Link } from 'react-router-dom';
import './LifeAtSchool.css';

const LifeAtSchool = () => {
  const activities = [
    { name: 'MUSIC', icon: '🎵', slug: 'music' },
    { name: 'DANCE', icon: '💃', slug: 'dance' },
    { name: 'ARTS', icon: '🎨', slug: 'arts' },
    { name: 'SPORTS', icon: '⚽', slug: 'sports' },
    { name: 'DRAMATICS', icon: '🎭', slug: 'dramatics' },
    { name: 'P.SPEAKING', icon: '🗣️', slug: 'public-speaking' },
    { name: 'SKATING', icon: '⛸️', slug: 'skating' },
    { name: 'YOGA', icon: '🧘', slug: 'yoga' }
  ];

  return (
    <section className="life-section">
      <div className="container">
        <h2 className="section-title">LIFE AT PRAGATI VIDYALAYA SCHOOL</h2>
        <div className="life-content">
          <h3 className="section-subtitle">A CAMPUS OF EXCELLENCE</h3>
          <p className="life-description">
            Educational Torch of Pragati Vidyalaya which has been glowing for the past 13 years 
            and with time has brightened and become an empowering "Light of Knowledge" that is 
            constantly spearding, speakling and above all imparting valuable learning to all our 
            students. We follow a relentless path which inculcates in each and every student not 
            only deep knowledge but also instills values that encourage them all to give importance 
            to our age old culture, tradition, descipline and manners so that they are well trained 
            to step out into the world as exemplary citizens of our proud country. We wish them all 
            Good Luck for thier brigter and happier future. We encourage and enable our students to 
            explore their interests, hone their talents and pursue their passion in music, dance, 
            art, sports and many other activities.
          </p>
        </div>
        <div className="activities-grid">
          {activities.map((activity, index) => (
            <Link to={`/activities/${activity.slug}`} key={index} className="activity-card">
              <div className="activity-icon">{activity.icon}</div>
              <div className="activity-name">{activity.name}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifeAtSchool;

